import { IUtilsEmailState, GlobalService, LogService } from '@medlogic/shared/shared-interfaces';
import { createSelector, createFeatureSelector } from '@ngrx/store';
import * as fromEmails from './state-utils-email.reducer';

const glb = new GlobalService();
const log = new LogService();

export const isEmailsLoading = createSelector(
  fromEmails.selectAll,
  state => !!state,
);

export const selectEmailsState = createFeatureSelector<IUtilsEmailState>(fromEmails.utilsEmailFeatureKey);
export const selectEmailsAlls = createSelector(selectEmailsState, fromEmails.selectAll);
